(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContratoNewController",
            ConsortiumContratoNewController
        );

    ConsortiumContratoNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumContrato",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumContratoNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumContrato,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumContrato = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContrato = Object.assign({}, vm.consortiumContrato);
            consortiumContrato.id = null;
            ConsortiumContrato.save(
                consortiumContrato,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-contrato", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
